import { useCallback, useEffect } from "react";
import sendGtmEvent from "web/utils/system/GTM/sendGtmEvent";

const CATEGORY = "Promocja aplikacji - Kafeteria";

const parsedStoreNames = {
  "App Store": "AppStore",
  "App Gallery": "AppGallery",
};

function useAppPromoGtm({ storeName = "" }: { storeName: string | null }) {
  useEffect(() => {
    sendGtmEvent("GAevent", {
      "gtm_event_name": "promocja_aplikacji",
      eventCategory: CATEGORY,
      eventAction: "Wyświetlenie banneru",
      eventLabel: parsedStoreNames[storeName as keyof typeof parsedStoreNames] ?? storeName,
      eventValue: 0,
      eventNonInteraction: true,
    });
  }, []);

  const trackClick = useCallback(() => {
    sendGtmEvent("GAevent", {
      "gtm_event_name": "promocja_aplikacji",
      eventCategory: CATEGORY,
      eventAction: "Przejście do sklepu",
      eventLabel: parsedStoreNames[storeName as keyof typeof parsedStoreNames] ?? storeName,
      eventValue: 0,
      eventNonInteraction: true,
    });
  }, [storeName]);

  const trackRemindLater = () => {
    sendGtmEvent("GAevent", {
      "gtm_event_name": "promocja_aplikacji",
      eventCategory: CATEGORY,
      eventAction: "Pominięcie banneru",
      eventLabel: parsedStoreNames[storeName as keyof typeof parsedStoreNames] ?? storeName,
      eventValue: 0,
      eventNonInteraction: true,
    });
  };

  return { onStoreClick: trackClick, onRemindLater: trackRemindLater };
}

export default useAppPromoGtm;
